import { HttpParams } from "@angular/common/http";
import { ICriteria } from "src/app/core/services/criteria.interface";

export class UserCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'Surname asc';
  filterActive: string = 'active';
  searchTerm: string = null;

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    if (this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True and (Surname.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '"))')
    }

    if (this.searchTerm && this.filterActive == 'inActive') {
      params = params.set('filter', 'IsActive == False and (Surname.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '"))')
    }

    if (this.searchTerm && this.filterActive == 'all') {
      params = params.set('filter', 'Surname.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '")')
    }

    if (!this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True')
    }

    if (!this.searchTerm && this.filterActive == 'inActive') {
      params = params.set('filter', 'IsActive == False')
    }

    return params;
  }
}
